export default __webpack_public_path__ + "static/media/MnVBG.0284bdcd.jpg";